import Analytics from 'analytics';
import segmentPlugin from '@analytics/segment';

const analytics = Analytics({
  app: 'QA Assistant',
  plugins: [
    segmentPlugin({
      writeKey: process.env.SEGMENT_WRITE_KEY,
    }),
  ],
});

export const sendSegment = analytics.track;
export const identifySegment = analytics.identify;
